import { reactive } from 'vue'


// EXPORT
export const state = reactive({
    widgetSettings: [],
    currentWidgetStep: {},
    
    getWidgetSettings() {
        return this.widgetSettings;
    },

    setWidgetSettings(widgetSettings) {
        this.widgetSettings = widgetSettings;
    },

    getCurrentWidgetStep() {
        return this.currentWidgetStep;
    },

    setCurrentWidgetStep(step) {
        this.currentWidgetStep = step;
    }

});